"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionResult = exports.ProdSysBase = void 0;
const Utilities_1 = require("../Utilities");
class ProdSysBase {
    static Open(instance, options) {
        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("prodsysnotimplemented"));
        return new ActionResult(true, instance.id.valueAsString);
    }
    static View(instance, options) {
        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("prodsysnotimplemented"));
        return new ActionResult(true, instance.id.valueAsString);
    }
}
exports.ProdSysBase = ProdSysBase;
class ActionResult {
    constructor(handled, id) {
        this.handled = handled;
        this.id = id;
    }
}
exports.ActionResult = ActionResult;
